module.exports = __webpack_public_path__ + "static/media/mobile834.3a19a0dc.png";